import React, { useEffect } from "react";
import PageTop from "../../components/PageTop/PageTop";
import MainNav from "../../shared/MainNav/MainNav";
import Service from "../../components/Service/Service";
import ContactUS from "../../components/ContactUs/ContactUs";
import Footer from "../../components/Footer/Footer";

export default function ServicePage() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  return (
    <>
      <MainNav title="Services" />
      <PageTop pageTitle="My Services" />
      <Service />
      <ContactUS />
      <Footer />
    </>
  );
}
